<template>
  <v-container id="purchases" fluid tag="section">
    <v-row justify="center" class="mx-10">
      <v-col cols="12" md="3">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Expenses") }}</h2>
          </div>
          <v-col
            cols="12 my-5"
            @mouseenter="expenseAdd = true"
            @mouseleave="expenseAdd = false"
          >
            <v-row>
              <router-link v-if="$ha(1200)" :to="'/expenses'">
                <h4 class="">{{ $i18n.t("Expenses") }}</h4>
              </router-link>
              <router-link
                :to="'/expense/create'"
                v-if="expenseAdd && $ha(1200)"
                class="ms-10"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="articleAdd = true"
            @mouseleave="articleAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=ArticlePurchase'"
              >
                <h4 class="">{{ $i18n.t("Article Purchase") }}</h4>
              </router-link>
              <router-link
                v-if="articleAdd && $ha(1200)"
                :to="'/expense/create?accountCode=ArticlePurchase'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="vehExpAdd = true"
            @mouseleave="vehExpAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=VehicleExpense'"
              >
                <h4 class="">{{ $i18n.t("Vehicle Expense") }}</h4>
              </router-link>
              <router-link
                v-if="vehExpAdd && $ha(1200)"
                :to="'/expense/create?accountCode=VehicleExpense'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="drvExpAdd = true"
            @mouseleave="drvExpAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=DriverExpense'"
              >
                <h4 class="">{{ $i18n.t("Driver Expense") }}</h4>
              </router-link>
              <router-link
                v-if="drvExpAdd && $ha(1200)"
                :to="'/expense/create?accountCode=DriverExpense'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="salaryAdd = true"
            @mouseleave="salaryAdd = false"
          >
            <v-row>
              <router-link v-if="$ha(1200)" :to="'/expenses?_account=Salary'">
                <h4 class="">{{ $i18n.t("Salary") }}</h4>
              </router-link>
              <router-link
                v-if="salaryAdd && $ha(1200)"
                :to="'/expense/create?accountCode=Salary'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="rentAdd = true"
            @mouseleave="rentAdd = false"
          >
            <v-row>
              <router-link v-if="$ha(1200)" :to="'/expenses?_account=Rent'">
                <h4 class="">{{ $i18n.t("Rent") }}</h4>
              </router-link>
              <router-link
                v-if="rentAdd && $ha(1200)"
                :to="'/expense/create?accountCode=Rent'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="ofcAdd = true"
            @mouseleave="ofcAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=OfficeExpense'"
              >
                <h4 class="">{{ $i18n.t("Office Expense") }}</h4>
              </router-link>
              <router-link
                v-if="ofcAdd && $ha(1200)"
                :to="'/expense/create?accountCode=OfficeExpense'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="genrealAdd = true"
            @mouseleave="genrealAdd = false"
          >
            <v-row>
              <router-link v-if="$ha(1200)" :to="'/expenses?_account=General'">
                <h4 class="">{{ $i18n.t("General") }}</h4>
              </router-link>
              <router-link
                v-if="genrealAdd && $ha(1200)"
                :to="'/expense/create?accountCode=General'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="billAdd = true"
            @mouseleave="billAdd = false"
          >
            <v-row>
              <router-link v-if="$ha(1200)" :to="'/bills'">
                <h4 class="">{{ $i18n.t("Bills") }}</h4>
              </router-link>
              <router-link v-if="billAdd && $ha(1200)" :to="'/bill/create'">
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="pmntdnAdd = true"
            @mouseleave="pmntdnAdd = false"
          >
            <v-row>
              <router-link v-if="$ha(1200)" :to="'/paymentdones'">
                <h4 class="">{{ $i18n.t("Payments Done") }}</h4>
              </router-link>
              <router-link
                v-if="pmntdnAdd && $ha(1200)"
                :to="'/paymentdone/create'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col cols="12 my-5">
            <v-row>
              <router-link v-if="$ha(1200)" :to="'/paymentpending'">
                <h4 class="">{{ $i18n.t("Pending Payments") }}</h4>
              </router-link>
            </v-row>
          </v-col>
        </div>
      </v-col>

      <v-col cols="12" md="3">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Advance") }}</h2>
          </div>

          <v-col
            cols="12 my-5"
            @mouseenter="drvCshAdd = true"
            @mouseleave="drvCshAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=DriverCashAdvance'"
              >
                <h4 class="">{{ $i18n.t("Driver Cash Advance") }}</h4>
              </router-link>
              <router-link
                v-if="drvCshAdd && $ha(1200)"
                :to="'/expense/create?accountCode=DriverCashAdvance'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="supAdvAdd = true"
            @mouseleave="supAdvAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=SupplierAdvance'"
              >
                <h4 class="">{{ $i18n.t("Supplier Advance") }}</h4>
              </router-link>
              <router-link
                v-if="supAdvAdd && $ha(1200)"
                :to="'/expense/create?accountCode=SupplierAdvance'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="trpExpAdd = true"
            @mouseleave="trpExpAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=TripExpenseAdvance'"
              >
                <h4 class="">{{ $i18n.t("Trip Expense Advance") }}</h4>
              </router-link>
              <router-link
                v-if="trpExpAdd && $ha(1200)"
                :to="'/expense/create?accountCode=TripExpenseAdvance'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="salAvdAdd = true"
            @mouseleave="salAvdAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=SalaryAdvance'"
              >
                <h4 class="">{{ $i18n.t("Salary Advance") }}</h4>
              </router-link>
              <router-link
                v-if="salAvdAdd && $ha(1200)"
                :to="'/expense/create?accountCode=SalaryAdvance'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>
        </div>
      </v-col>

      <v-col cols="12" md="3">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Assets") }}</h2>
          </div>
          <!-- <router-link v-if="$ha(1200)" :to="'/drivers">
            <h4 class="my-5">{{ $i18n.t("Asset Purchases") }}</h4>
          </router-link> -->

          <v-col
            cols="12 my-5"
            @mouseenter="drvFundAdd = true"
            @mouseleave="drvFundAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=DriverFundReturn'"
              >
                <h4 class="">{{ $i18n.t("Driver Fund Return") }}</h4>
              </router-link>
              <router-link
                v-if="drvFundAdd && $ha(1200)"
                :to="'/expense/create?accountCode=DriverFundReturn'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="supExpAdd = true"
            @mouseleave="supExpAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=SupplierFundReturn'"
              >
                <h4 class="">{{ $i18n.t("Supplier Fund Return") }}</h4>
              </router-link>
              <router-link
                v-if="supExpAdd && $ha(1200)"
                :to="'/expense/create?accountCode=SupplierFundReturn'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="trpExpRAdd = true"
            @mouseleave="trpExpRAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=TripExpenseReturn'"
              >
                <h4 class="">{{ $i18n.t("Trip Expense Return") }}</h4>
              </router-link>
              <router-link
                v-if="trpExpRAdd && $ha(1200)"
                :to="'/expense/create?accountCode=TripExpenseReturn'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>

          <v-col
            cols="12 my-5"
            @mouseenter="openBalAdd = true"
            @mouseleave="openBalAdd = false"
          >
            <v-row>
              <router-link v-if="$ha(1200)" :to="'/openingbalances'">
                <h4 class="">{{ $i18n.t("Opening balance") }}</h4>
              </router-link>
              <router-link
                v-if="openBalAdd && $ha(1200)"
                :to="'/openingbalance/create'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>
        </div>

        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Article Inventory") }}</h2>
          </div>
          <router-link v-if="$ha(1200)" :to="'/inventories'">
            <h4 class="my-5">{{ $i18n.t("Inventory") }}</h4>
          </router-link>
        </div>
      </v-col>

      <v-col cols="12" md="3">
        <div class="margin-bottom-40">
          <div class="margin-bottom-40">
            <h2>{{ $i18n.t("Liability") }}</h2>
          </div>

          <v-col
            cols="12 my-5"
            @mouseenter="credAdd = true"
            @mouseleave="credAdd = false"
          >
            <v-row>
              <router-link
                v-if="$ha(1200)"
                :to="'/expenses?_account=CreditNote'"
              >
                <h4 class="">{{ $i18n.t("Credit Note") }}</h4>
              </router-link>
              <router-link
                v-if="credAdd && $ha(1200)"
                :to="'/expense/create?accountCode=CreditNote'"
              >
                <h4 class="mx-5"><v-icon>mdi-plus-thick</v-icon></h4>
              </router-link>
            </v-row>
          </v-col>
          <!-- <router-link v-if="$ha(1200)" :to="'/expenses?_account=Loan">
            <h4 class="my-5">{{ $i18n.t("Loan") }}</h4>
          </router-link>
          <router-link  v-if="$ha(1200)" :to="'/expenses?_account=LoanEMI">
            <h4 class="my-5">{{ $i18n.t("Loan EMI") }}</h4>
          </router-link> -->
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Purchases",

  data() {
    return {
      expenseAdd: false,
      articleAdd: false,
      vehExpAdd: false,
      drvExpAdd: false,
      salaryAdd: false,
      supExpAdd: false,
      trpExpAdd: false,
      openBalAdd: false,
      credAdd: false,
      drvFundAdd: false,
      salAvdAdd: false,
      trpExpRAdd: false,
      supAdvAdd: false,
      genrealAdd: false,
      billAdd: false,
      drvCshAdd: false,
      pmntdnAdd: false,
      ofcAdd: false,
      rentAdd: false,
    };
  },

  methods: {
    complete(index) {
      this.list[index] = !this.list[index];
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.to-show {
  display: none;
  margin-left: 40px;
}
.on-hover:hover > .to-show {
  display: block;
}
.on-hover a {
  float: left;
}
</style>
